<template>
  <div class="wrapper">
    <button @click="handleSubmit" type="button" class="btn btn-default" :class="{'is-text': type==='text', 'is-info': type==='info'}">
      <img v-if="isShow" class="icon" :src="icon[0].url" />
      <img v-else class="icon" :src="icon[1].url" />
      <!--      <span>隐私</span>-->
    </button>
    <base-modal :show-close="false" :center="true" :visible.sync="isVerificationCodeLayer">
      <div class="verification-wrapper">
        <h3 class="title">安全验证</h3>
        <div class="verification-code" id="captcha"></div>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {Dialog} from "vant";
import api from '@/api'
import BaseModal from './BaseModal'


export default {
  name: "PrivacyButton",
  props: {
    type: {
      type: String,
      default: 'btn'
    },
    reload:{
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      token: "",
      isShow: true,
      iconUrl: require("@/assets/icons/icon-visible.png"),
      icon: [{
        url: require("@/assets/icons/icon-invisible.png")
      },{
        url: require("@/assets/icons/icon-visible.png")
      }],
      isAllowNvc: true,
      isVerificationCodeLayer: false
    }
  },
  components: {
    BaseModal
  },
  created() {
    this.token = this.$store.state.token;
     this.getPrivacyProtectionStatus();
  },
  beforeMount() {
     this.initAWSC();
  },
  methods: {
    async handleSubmit () {
      if (!this.isAllowNvc) {
        return;
      }

      // 人机验证
      if (!window.nvc) return;

      // this.$loading.show();
      window.nvc.getNVCValAsync(async (nvcVal) => {
        // console.log(nvcVal)
        // 无痕验证获取nvc data，用无痕验证模式调是否用开启隐私保护接口
        const request = this.getRequest("AliYunAfsNvc", nvcVal);
        await this.updatePrivacyStatus(request);
      });

    },
    async getPrivacyProtectionStatus () {
      const token = this.$store.state.token;
      const { success, data, errMsg } = await api.changePrivacyProtectionIsOpen(token)
      if(success) {
        //data是隐私保护状态,true是开启,false为关闭
        this.isShow = data;
        this.$store.commit("SET_IS_MASK_VALUE", data);
      } else {
        console.log(errMsg)
        Dialog.alert({
          message: errMsg
        })
        // this.$alert.show(errMsg)
      }
    },
    initAWSC () {
      console.log("initAWSC")
      if (!window.AWSC) return
      window.AWSC.use("nvc", (state, module) => {
        // 初始化 调用module.init进行初始化
        window.nvc = module.init({
          appkey: "FFFF0N00000000009D85",
          scene: "nvc_message",
          renderTo:'#captcha',
          // test: module.TEST_NC_PASS,
          // 二次验证获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
          success: async (data) => {
            this.isVerificationCodeLayer = false;
            // this.$loading.show();
            const request = this.getRequest("AliYunAfsNc", data);
            await this.updatePrivacyStatus(request);
          },
          // 前端二次验证失败时触发该回调参数
          fail: (failCode) => {
            window.console && console.log(failCode);
            this.isAllowNvc = false;
          },
          // 前端二次验证加载异常时触发该回调参数。
          error: (errorCode) => {
            window.console && console.log(errorCode);
            this.isAllowNvc = false;
          }
        });
      });
    },
    async updatePrivacyStatus(request) {
      if (!this.isAllowNvc) return;
      const { success, data, errMsg } = await api.updateUserPrivacyProtection(request);
      console.log('update reselut',data)
      if (!success) {
        if (errMsg === 'NvcNc' || errMsg === 'Block') {
          this.afsFailureHandler(errMsg)
        } else {
          Dialog.alert({
            message: errMsg
          })
        }
      } else {
        this.$store.commit("SET_IS_MASK_VALUE", !this.isShow);
        this.isShow =!this.isShow;
        this.$emit("switch", true);
      }
    },
    // 无痕验证模式发送短信失败处理方法
    afsFailureHandler(code) {
      this.isVerificationCodeLayer = true;
      // 行为可疑，进入二次滑动验证
      if (code === 'NvcNc') {
        const ncoption = {
          renderTo: "#captcha",
        }
        let childNodes = document.getElementById('captcha').childNodes;
        for (let i = 0; i < childNodes.length; i++) {
          let childNode = childNodes[i];
          childNode.parentElement.removeChild(childNode);
        }
        // 唤醒二次验证（滑动验证码）
        window.nvc.getNC(ncoption);
      } else if (code === 'Block') {
        // 返回block，禁止提交
        this.isAllowNvc = false
        // this.$alert.show(
        //     "网络错误，请刷新页面重试。"
        // );
        Dialog.alert({
          message: '网络错误，请刷新页面重试。'
        })
      }
    },
    getRequest (codeType, codeValue) {
      return {
        userName: this.token,
        isOpenPrivacyProtection: !this.isShow,
        codeType: codeType,
        codeValue: codeValue
      };
    }
  }
}
</script>

<style scoped lang="less">

.btn {
  height: 36px;
  border: none;
  border-radius: 0;
  padding: 0 12px 0 39px;
  position: relative;
  font-size: 16px;
  &:focus {
    outline: none;
  }
  &.btn-default {
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
    &.is-text {
      height: auto;
      padding: 0;
      background-color: transparent;
      border: none;
    }
    &.is-info {
      height: 25px;
      background-color: #FFFFFF;
      border: 1px solid #cccccc;
      & .icon {
        height: 20px;
        width: 20px;
      }
    }
  }
  & .icon {
    height: 22px;
    width: 22px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
  }
}
.verification-wrapper{
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
}
#captcha {
  position: relative;
  margin-top: 40px;
  .nc_wrapper {
    width: 100%;
    background-color: #0f254c;
  }
}
.title {
  margin: 10px auto 0;
  text-align: center;
  font-size: 30px;
}
</style>